import React from "react";

const DermatologyConditions = () => {
  const conditions = [
    { name: "Acne", url: "https://www.skinhealthinfo.org.uk/condition/acne/" },
    {
      name: "Actinic Keratoses",
      url: "https://www.skinhealthinfo.org.uk/condition/actinic-keratoses/",
    },
    // {
    //   name: "Actinic Prurigo",
    //   url: "https://www.skinhealthinfo.org.uk/condition/actinic-prurigo/",
    // },
    {
      name: "Alopecia Areata",
      url: "https://www.skinhealthinfo.org.uk/condition/alopecia-areata/",
    },
    {
      name: "Atopic Eczema",
      url: "https://www.skinhealthinfo.org.uk/condition/atopic-eczema/",
    },
    // {
    //   name: "Atypical Mole Syndrome",
    //   url: "https://www.skinhealthinfo.org.uk/condition/atypical-mole-syndrome/",
    // },
    {
      name: "Balanitis",
      url: "https://www.skinhealthinfo.org.uk/condition/zoons-balanitis/",
    },
    {
      name: "Basal Cell Carcinoma",
      url: "https://www.skinhealthinfo.org.uk/condition/basal-cell-carcinoma/",
    },
    // {
    //   name: "Becker’s Naevus",
    //   url: "https://www.skinhealthinfo.org.uk/condition/beckers-naevus/",
    // },
    // {
    //   name: "Behcet’s Skin Disease",
    //   url: "https://www.skinhealthinfo.org.uk/condition/behcets/",
    // },
    // {
    //   name: "Birt Hogg Dube’s Syndrome",
    //   url: "https://www.skinhealthinfo.org.uk/condition/birt-hogg-dube-syndrome/",
    // },
    // {
    //   name: "Blue Rubber Bleb Naevus Syndrome",
    //   url: "https://www.skinhealthinfo.org.uk/condition/blue-rubber-bleb-naevus-syndrome/",
    // },
    {
      name: "Boils",
      url: "https://www.skinhealthinfo.org.uk/condition/boils/",
    },
    {
      name: "Capillaritis",
      url: "https://www.skinhealthinfo.org.uk/condition/capillaritis/",
    },
    {
      name: "Cellulitis and Erisypelas",
      url: "https://www.skinhealthinfo.org.uk/condition/cellulitis-and-erysipelas/",
    },
    {
      name: "Chondrodermatitis Nodularis",
      url: "https://www.skinhealthinfo.org.uk/condition/chondrodermatitis-nodularis/",
    },
    // {
    //   name: "Chronic Actinic Dermatitis",
    //   url: "https://www.skinhealthinfo.org.uk/condition/chronic-actinic-dermatitis/",
    // },
    {
      name: "Chronic Paronychia",
      url: "https://www.skinhealthinfo.org.uk/condition/chronic-paronychia/",
    },
    // {
    //   name: "Congenital Dermal Melanocytosis",
    //   url: "https://www.skinhealthinfo.org.uk/condition/congenital-dermal-melanocytosis/",
    // },
    {
      name: "Contact Dermatitis",
      url: "https://www.skinhealthinfo.org.uk/condition/contact-dermatitis/",
    },
    {
      name: "Cutaneous Vasculitis",
      url: "https://www.skinhealthinfo.org.uk/condition/cutaneous-vasculitis/",
    },
    {
      name: "Cysts (Epidermoid and Pillar)",
      url: "https://www.skinhealthinfo.org.uk/condition/epidermoid-and-pilar-cysts/",
    },
    {
      name: "Dermatitis Herpetiformis",
      url: "https://www.skinhealthinfo.org.uk/condition/dermatitis-herpetiformis-gluten-sensitivity/",
    },
    {
      name: "Dermatofibroma (Histiocytoma)",
      url: "https://www.skinhealthinfo.org.uk/condition/dermatofibroma-also-known-as-histiocytoma/",
    },
    {
      name: "Discoid Eczema",
      url: "https://www.skinhealthinfo.org.uk/condition/discoid-eczema/",
    },
    {
      name: "Discoid Lupus Erythematosus",
      url: "https://www.skinhealthinfo.org.uk/condition/discoid-lupus-erythematosus-dle/",
    },
    {
      name: "Dysplastic (Atypical) Naevus",
      url: "https://www.skinhealthinfo.org.uk/condition/dysplastic-atypical-naevus/",
    },
    {
      name: "Eczema Herpeticum",
      url: "https://www.skinhealthinfo.org.uk/condition/eczema-herpeticum/",
    },
    {
      name: "Erosive Pustular Dermatosis",
      url: "https://www.skinhealthinfo.org.uk/condition/erosive-pustular-dermatosis-epd/",
    },
    {
      name: "Erythema Multiforme",
      url: "https://www.skinhealthinfo.org.uk/condition/erythema-multiforme/",
    },
    {
      name: "Erythema Nodosum",
      url: "https://www.skinhealthinfo.org.uk/condition/erythema-nodosum/",
    },
    {
      name: "Folliculitis Barbae",
      url: "https://www.skinhealthinfo.org.uk/condition/folliculitis-barbae/",
    },
    {
      name: "Fungal Nail Infections",
      url: "https://www.skinhealthinfo.org.uk/condition/fungal-infections-of-the-nails/",
    },
    {
      name: "Granuloma Annulare",
      url: "https://www.skinhealthinfo.org.uk/condition/granuloma-annulare/",
    },
    // {
    //   name: "Hair Loss Female Pattern (Androgenetic Alopecia)",
    //   url: "https://www.skinhealthinfo.org.uk/condition/female-pattern-hair-loss-androgenetic-alopecia/",
    // },
    // {
    //   name: "Hair Loss Male Pattern (Androgenetic Alopecia)",
    //   url: "https://www.skinhealthinfo.org.uk/condition/male-pattern-hair-loss-androgenetic-alopecia/",
    // },
    {
      name: "Hand Dermatitis (Hand Eczema)",
      url: "https://www.skinhealthinfo.org.uk/condition/hand-dermatitis-hand-eczema/",
    },
    {
      name: "Herpes Simplex",
      url: "https://www.skinhealthinfo.org.uk/condition/herpes-simplex/",
    },
    {
      name: "Hidradenitis Suppurativa",
      url: "https://www.skinhealthinfo.org.uk/condition/hidradenitis-suppurativa/",
    },
    // {
    //   name: "Hirsutism",
    //   url: "https://www.skinhealthinfo.org.uk/condition/hirsutism/",
    // },
    {
      name: "Hyperhidrosis (Excessive Sweating)",
      url: "https://www.skinhealthinfo.org.uk/condition/hyperhidrosis/",
    },
    // {
    //   name: "Icthyosis",
    //   url: "https://www.skinhealthinfo.org.uk/condition/ichthyosis/",
    // },
    {
      name: "Impetigo",
      url: "https://www.skinhealthinfo.org.uk/condition/impetigo/",
    },
    // {
    //   name: "Kaposi’s Sarcoma",
    //   url: "https://www.skinhealthinfo.org.uk/condition/kaposis-sarcoma/",
    // },
    {
      name: "Keloids",
      url: "https://www.skinhealthinfo.org.uk/condition/keloids/",
    },
    {
      name: "Keratocanthoma",
      url: "https://www.skinhealthinfo.org.uk/condition/keratoacanthoma/",
    },
    {
      name: "Keratosis Pilaris",
      url: "https://www.skinhealthinfo.org.uk/condition/keratosis-pilaris/",
    },
    {
      name: "Lentigo Maligna",
      url: "https://www.skinhealthinfo.org.uk/condition/lentigo-maligna/",
    },
    {
      name: "Lichen Planus",
      url: "https://www.skinhealthinfo.org.uk/condition/lichen-planus/",
    },
    // {
    //   name: "Lichen Sclerosus in Females",
    //   url: "https://www.skinhealthinfo.org.uk/condition/lichen-sclerosus-in-females/",
    // },
    // {
    //   name: "Lichen Sclerosus in Males",
    //   url: "https://www.skinhealthinfo.org.uk/condition/lichen-sclerosus-in-males/",
    // },
    {
      name: "Lichen Simplex",
      url: "https://www.skinhealthinfo.org.uk/condition/lichen-simplex/",
    },
    // {
    //   name: "Lymphoedema",
    //   url: "https://www.skinhealthinfo.org.uk/condition/lymphoedema/",
    // },
    {
      name: "Melanocyotic Naevi (Pigmented Moles)",
      url: "https://www.skinhealthinfo.org.uk/condition/melanocytic-naevi-pigmented-moles/",
    },
    {
      name: "Melanoma",
      url: "https://www.skinhealthinfo.org.uk/condition/melanoma-in-situ/",
    },
    // {
    //   name: "Melasma",
    //   url: "https://www.skinhealthinfo.org.uk/condition/melasma/",
    // },
    {
      name: "Molluscum Contagiosum",
      url: "https://www.skinhealthinfo.org.uk/condition/molluscum-contagiosum/",
    },
    {
      name: "Necrobiosis Lipoidica",
      url: "https://www.skinhealthinfo.org.uk/condition/necrobiosis-lipoidica/",
    },
    // {
    //   name: "Necrotising Fasciitis",
    //   url: "https://www.skinhealthinfo.org.uk/condition/necrotising-fasciitis/",
    // },
    // {
    //   name: "Neurofibromatosis",
    //   url: "https://www.skinhealthinfo.org.uk/condition/neurofibromatosis/",
    // },
    // {
    //   name: "Pellagra",
    //   url: "https://www.skinhealthinfo.org.uk/condition/pellagra/",
    // },
    {
      name: "Pemphigoid",
      url: "https://www.skinhealthinfo.org.uk/condition/pemphigoid/",
    },
    // {
    //   name: "Pemphigus",
    //   url: "https://www.skinhealthinfo.org.uk/condition/pemphigus/",
    // },
    // {
    //   name: "Pityriasis Lichenoides",
    //   url: "https://www.skinhealthinfo.org.uk/condition/pityriasis-lichenoides/",
    // },
    {
      name: "Pityriasis Versicolor",
      url: "https://www.skinhealthinfo.org.uk/condition/pityriasis-versicolor/",
    },
    // {
    //   name: "Polymorphic Light Eruption",
    //   url: "https://www.skinhealthinfo.org.uk/condition/polymorphic-light-eruption/",
    // },
    // {
    //   name: "Porphyria Cutanea Tarda",
    //   url: "https://www.skinhealthinfo.org.uk/condition/porphyria-cutanea-tarda/",
    // },
    // {
    //   name: "Pseudoxanthoma Elasticum",
    //   url: "https://www.skinhealthinfo.org.uk/condition/pseudoxanthoma-elasticum/",
    // },
    {
      name: "Psoriasis",
      url: "https://www.skinhealthinfo.org.uk/condition/psoriasis/",
    },
    {
      name: "Pyoderma Gangrenosum",
      url: "https://www.skinhealthinfo.org.uk/condition/pyoderma-gangrenosum/",
    },
    // {
    //   name: "Raynaud’s Phenomenon",
    //   url: "https://www.skinhealthinfo.org.uk/condition/raynauds-phenomenon/",
    // },
    // {
    //   name: "Rhinophyma",
    //   url: "https://www.skinhealthinfo.org.uk/condition/rhinophyma/",
    // },
    {
      name: "Rosacea",
      url: "https://www.skinhealthinfo.org.uk/condition/rosacea/",
    },
    {
      name: "Sarcoidosis",
      url: "https://www.skinhealthinfo.org.uk/condition/sarcoidosis/",
    },
    {
      name: "Scabies",
      url: "https://www.skinhealthinfo.org.uk/condition/scabies/",
    },
    {
      name: "Seborrhoeic Keratoses",
      url: "https://www.skinhealthinfo.org.uk/condition/seborrhoeic-keratoses/",
    },
    {
      name: "Seborrhoeic Dermatitis",
      url: "https://www.skinhealthinfo.org.uk/condition/seborrhoeic-dermatitis/",
    },
    {
      name: "Squamous Cell Carcinoma",
      url: "https://www.skinhealthinfo.org.uk/condition/squamous-cell-carcinoma/",
    },
    // {
    //   name: "Stevens-Johnson Syndrome and Toxic Epidermal Necrolysis",
    //   url: "https://www.skinhealthinfo.org.uk/condition/stevens-johnson-syndrome-and-toxic-epidermal-necrolysis/",
    // },
    // {
    //   name: "Subcorneal Pustular Dermatosis",
    //   url: "https://www.skinhealthinfo.org.uk/condition/subcorneal-pustular-dermatosis/",
    // },
    // {
    //   name: "Sweet’s Syndrome",
    //   url: "https://www.skinhealthinfo.org.uk/condition/sweets-syndrome/",
    // },
    {
      name: "Tinea (Fungal Infection)",
      url: "https://www.skinhealthinfo.org.uk/condition/tinea-fungal-infection/",
    },
    // {
    //   name: "Tuberous Sclerosis",
    //   url: "https://www.skinhealthinfo.org.uk/condition/tuberous-sclerosis/",
    // },
    {
      name: "Urticaria",
      url: "https://www.skinhealthinfo.org.uk/condition/urticaria/",
    },
    {
      name: "Viral Warts",
      url: "https://www.skinhealthinfo.org.uk/condition/viral-warts/",
    },
    {
      name: "Vitiligo",
      url: "https://www.skinhealthinfo.org.uk/condition/vitiligo/",
    },
    // {
    //   name: "Wegener’s Granulomatosis",
    //   url: "https://www.skinhealthinfo.org.uk/condition/wegners-granulomatosis/",
    // },
    // {
    //   name: "Woolly Hair",
    //   url: "https://www.skinhealthinfo.org.uk/condition/woolly-hair/",
    // },
  ];

  const additionalInfo = [
    {
      name: "British Association of Dermatology (BAD) patient information",
      url: "https://www.bad.org.uk/patient-information-leaflets/",
    },
    { name: "DermNet", url: "https://dermnetnz.org/topics" },
  ];

  return (
    <div style={{ margin:"0 20px"  }}>
      <p style={{ textAlign: "start", color:"black", fontSize:"22px", fontWeight:"400" }}>
        Dr Ahmed diagnoses and treats all skin diseases affecting adults
        including:
      </p>
      <ul style={{ listStyleType: "disc",marginLeft:"20px" , lineHeight: "60px", }}>
        {conditions.map((condition, index) => (
          <li key={index} style={{ position: "relative", zIndex: "1", fontSize:"19px", letterSpacing:".225px" }}>
            <a
              href={condition.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "black", textDecoration: "none" }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.textDecoration = "underline")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.textDecoration = "none")
              }
            >
              {condition.name}
            </a>
          </li>
        ))}
      </ul>
      <h4>
        For further more detailed information on an extensive range of skin
        diseases please see:
      </h4>
      <ul style={{ listStyleType: "disc", padding: "0 35px" }}>
        {additionalInfo.map((info, index) => (
          <li key={index} style={{ position: "relative", zIndex: "1", fontSize:"19px", letterSpacing:".225px" }}>
            <a
              href={info.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "black" }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.textDecoration = "underline")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.textDecoration = "none")
              }
            >
              {info.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DermatologyConditions;
